(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("pathsToLearnersAssignments", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/assignments/pathsToLearnersAssignmentsView.html",
            controller: ["assignmentMapsResource", "authService", "frameworkService", "$localStorage", "$sessionStorage", "$timeout", "$scope", "$state", "$compile", "$translate", "$uibModal", "messageService", "DTOptionsBuilder", PathsToLearnersAssignmentsCtrl],
            controllerAs: "vm"
        };
        function PathsToLearnersAssignmentsCtrl(assignmentMapsResource, authService, frameworkService, $localStorage, $sessionStorage, $timeout, $scope, $state, $compile, $translate, $uibModal, messageService, DTOptionsBuilder) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstance = {};
            var enable = $translate.instant("common.enable");
            var remove = $translate.instant("common.remove");
            var disable = $translate.instant("common.disable");
            var redo = $translate.instant("common.redo");
            var reassign = $translate.instant("common.reassign");
            vm.storefrontEnabled = frameworkService.data.tenantFeatures.storefront;
            buildTable();
            vm.filters = {
                firstName: { enabled: true, value: "" },
                lastName: { enabled: true, value: "" },
                pathName: { enabled: true, value: "" },
                status: { enabled: true, value: [] },
                orderSeq: { enabled: true, value: "" }
            };
            if ($sessionStorage.managePathsToLearnersAssignmentsFilters) {
                vm.filters = angular.merge(vm.filters, $sessionStorage.managePathsToLearnersAssignmentsFilters);
            }
            if ($state.params.orderSeq)
                vm.filters.orderSeq.value = $state.params.orderSeq;
            //EXAMPLE - datatable reloadTable if not already reloading
            var tableReloading = false;
            var reloadTableTimeout;
            vm.reloadTable = function () {
                if (tableReloading) {
                    if (reloadTableTimeout)
                        $timeout.cancel(reloadTableTimeout);
                    reloadTableTimeout = $timeout(function () {
                        vm.reloadTable();
                    }, 200);
                }
                else {
                    tableReloading = true;
                    $timeout(function () {
                        $sessionStorage.managePathsToLearnersAssignmentsFilters = vm.filters;
                        vm.dtInstance.reloadData(function () {
                            tableReloading = false;
                        });
                        //if you want logging
                        //vm.dtInstance.reloadData(function (json) {
                        //	tableReloading = false;
                        //	console.log(json);
                        //});
                    });
                }
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.managePathsToGroupsAssignmentsFilters = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.delete = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "deleteRecordConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    assignmentMapsResource.delete({ id: id }, function () {
                        var page = vm.dtInstance.DataTable.page();
                        vm.dtInstance.DataTable.page(page).draw(false);
                        messageService.success("common.recordDeleted");
                    }, function (error) {
                        vm.dtInstance.reloadData();
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.disable = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "disableRecordConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    assignmentMapsResource.disable({ id: id }, function () {
                        var page = vm.dtInstance.DataTable.page();
                        vm.dtInstance.DataTable.page(page).draw(false);
                        messageService.success("common.recordDisabled");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.enable = function (id) {
                assignmentMapsResource.enable({ id: id }, function () {
                    var page = vm.dtInstance.DataTable.page();
                    vm.dtInstance.DataTable.page(page).draw(false);
                    messageService.success("common.recordEnabled");
                }, function (error) {
                    messageService.error(error);
                });
            };
            vm.redo = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "redoConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    assignmentMapsResource.redo({ id: id }, function () {
                        var page = vm.dtInstance.DataTable.page();
                        vm.dtInstance.DataTable.page(page).draw(false);
                        messageService.success("common.changesSaved");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.reassign = function (id) {
                var modal = $uibModal.open({
                    templateUrl: "reassignConfirmation.html",
                    backdrop: false,
                    animation: false,
                    windowClass: "confirmation-modal"
                });
                modal.result.then(function () {
                    assignmentMapsResource.reassign({ id: id }, function () {
                        var page = vm.dtInstance.DataTable.page();
                        vm.dtInstance.DataTable.page(page).draw(false);
                        messageService.success("common.changesSaved");
                    }, function (error) {
                        messageService.error(error);
                    });
                }).catch(angular.noop);
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                vm.refreshFilter(vm.filters[filter].value);
            };
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "api/assignmentMaps/paths-to-learners",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "POST",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[1].search.value = vm.filters.firstName.enabled ? vm.filters.firstName.value : "";
                    data.columns[2].search.value = vm.filters.lastName.enabled ? vm.filters.lastName.value : "";
                    //data.columns[1].search.value = vm.filters.groupName.enabled ? vm.filters.groupName.value : "";
                    data.columns[3].search.value = vm.filters.pathName.enabled ? vm.filters.pathName.value : "";
                    data.columns[4].search.value = vm.filters.orderSeq.enabled ? vm.filters.orderSeq.value : "";
                    //data.columns[4].search.value = vm.filters.status.enabled ? vm.filters.status.value.join("|") : "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("rowCallback", rowCallback)
                .withOption("createdRow", function (row) {
                // Recompiling so we can bind Angular directive to the DT
                $compile(angular.element(row))($scope);
            })
                .withPaginationType("full_numbers")
                .withBootstrap();
            function buildTable() {
                //define Columns
                var responsiveColumn = { "data": null, "defaultContent": "", "class": "control", "sortable": false, "targets": 0 };
                var learnerColumn = {
                    responsivePriority: 1,
                    "data": "learner",
                    "sortable": false,
                    "title": $translate.instant("common.lists.learner"),
                    "render": function (data, type, full) {
                        return data + " (" + full.personSeq + ")";
                    }
                };
                //var groupColumn = { "data": "groups", "sortable": false, "title": $translate.instant("common.lists.learnersGroups") };
                var emailColumn = { "data": "email", "sortable": false, "title": $translate.instant("common.lists.email") };
                var pathNameColumn = {
                    responsivePriority: 2,
                    "data": "name",
                    "sortable": false,
                    "title": $translate.instant("common.lists.learningPath"),
                    "class": "break"
                };
                var assignedToColumn = {
                    "data": "assignedTo",
                    "sortable": false,
                    "title": $translate.instant("common.lists.assignedTo"),
                    "render": function (data) {
                        return $translate.instant(data);
                    }
                };
                var assignmentStatusColumn = {
                    "data": "assignmentStatus",
                    "sortable": false,
                    "title": $translate.instant("common.lists.status"),
                    "render": function (data) {
                        return $translate.instant("common.assignmentStatus." + data);
                    }
                };
                var actionColumn = {
                    responsivePriority: 2,
                    "data": null,
                    "sortable": false,
                    "title": $translate.instant("common.action"),
                    "render": function (_data, _type, full) {
                        var buttons;
                        if (full.assignmentStatus === "Disabled") {
                            buttons = "<button class='btn btn-xs btn-success' stop-event='click' ng-click='vm.enable(" + full.id + ")'>" + enable + "</button>";
                        }
                        else if (full.assignmentStatus === "Assigned") {
                            if (full.assignedTo === "common.learner")
                                buttons = "<button class='btn btn-xs btn-danger' stop-event='click' ng-click='vm.delete(" + full.id + ")'>" + remove + "</button>";
                            else
                                buttons = "<button class='btn btn-xs btn-warning' stop-event='click' ng-click='vm.disable(" + full.id + ")'>" + disable + "</button>";
                        }
                        else if (full.assignmentStatus === "Activated") {
                            buttons = "<button class='btn btn-xs btn-warning' stop-event='click' ng-click='vm.disable(" + full.id + ")'>" + disable + "</button>";
                        }
                        else if (full.assignmentStatus === "Completed") {
                            buttons = "";
                        }
                        else if (full.assignmentStatus === "Expired") {
                            buttons = "<button class='btn btn-xs btn-warning' stop-event='click' ng-click='vm.disable(" + full.id + ")'>" + disable + "</button>";
                        }
                        else {
                            buttons = "";
                        }
                        if (full.assignmentStatus !== "Redo") {
                            buttons = buttons + "<button class='btn btn-xs btn-warning' stop-event='click' ng-click='vm.redo(" + full.id + ")'>" + redo + "</button>";
                        }
                        if ((full.isReassignEnabled && full.assignmentStatus !== "Assigned") ||
                            (full.assignmentStatus === "AccessExpired" || full.assignmentStatus === "Expired" || full.assignmentStatus === "Redo")) {
                            buttons = buttons + "<button class='btn btn-xs btn-warning' stop-event='click' ng-click='vm.reassign(" + full.id + ")'>" + reassign + "</button>";
                        }
                        return "<div class='btn-group'>" + buttons + "</div>";
                    }
                };
                var orderSeqColumn = {
                    "data": "orderSeq",
                    "sortable": false,
                    "title": $translate.instant("common.lists.orderSeq"),
                    "class": "text-nowrap"
                };
                if (vm.storefrontEnabled) {
                    //Storefront enabled displays order #
                    vm.dtColumns = [
                        responsiveColumn,
                        learnerColumn,
                        emailColumn,
                        pathNameColumn,
                        assignedToColumn,
                        assignmentStatusColumn,
                        orderSeqColumn,
                        actionColumn
                    ];
                }
                else {
                    //Storefront not enabled Does not display order #
                    vm.dtColumns = [
                        responsiveColumn,
                        learnerColumn,
                        emailColumn,
                        pathNameColumn,
                        assignedToColumn,
                        assignmentStatusColumn,
                        actionColumn
                    ];
                }
            }
            function rowClickHandler(row) {
                $state.go("main.people.viewLearningPath", { personSeq: row.personSeq, number: row.pathNumber, version: row.pathVersion });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td:not(.control)", nRow).unbind("click");
                $("td:not(.control)", nRow).bind("click", function () {
                    $scope.$apply(function () {
                        rowClickHandler(aData);
                    });
                });
                return nRow;
            }
        }
    });
}());
